// PromoSlotsBadge.js
// Shared scarcity counter for the early-bird promo (lib/adsSchedule.js's
// spot-based runway): shown on the homepage header, the /bid checkout
// form, and the navbar bid-rank widget, all backed by the same
// usePromoSlots() fetch. Renders nothing until loaded.
import React from 'react';
import { Link } from 'react-router-dom';
import usePromoSlots from './hooks/usePromoSlots';
import './FeedbackButton.css';
import './PromoSlotsBadge.css';

// 'compact': a clickable button styled like FeedbackButton (header, navbar
// popover) — clicking it goes straight to the checkout form. 'full': a
// sentence explaining what the slots actually buy, for the checkout page
// itself, where someone's already there deciding whether to bid.
export default function PromoSlotsBadge({ variant = 'full', className = '' }) {
  const { ready, slotsRemaining, slotsTotal, baseDays } = usePromoSlots();

  if (!ready || slotsTotal == null || baseDays == null) return null;

  const soldOut = slotsRemaining <= 0;
  const classes = `promo-slots-badge promo-slots-badge-${variant} ${soldOut ? 'promo-slots-badge-soldout' : ''} ${className}`.trim();

  if (variant === 'compact') {
    return (
      <Link to="/bid" className={`feedback-btn ${classes}`}>
        {soldOut ? 'Early-bird slots full' : `🔥 ${slotsRemaining}/${slotsTotal} early-bird slots left`}
      </Link>
    );
  }

  const topDays = baseDays + slotsRemaining;
  return (
    <p className={classes}>
      {soldOut ? (
        'Early-bird slots are full — new bids now get a flat 7-day runway.'
      ) : (
        <>
          🔥 <strong>{slotsRemaining} of {slotsTotal}</strong> early-bird slots left.
          {' '}Bid now to lock in <strong>{topDays} days</strong> of runway. It shrinks by a day with every spot taken.
        </>
      )}
    </p>
  );
}
